import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, createStore } from 'redux';
import rootReducer from './reducers/rootReducer';
import rootSaga from './sagas/rootSaga';
import axiosInstance from '../axiosInstance';
import { setupLanguageInterceptor } from '../axiosInterceptors';

const nodeEnv = process.env.NODE_ENV;
const sagaMiddleware = createSagaMiddleware();
const middleware = applyMiddleware(sagaMiddleware);
const store = createStore(
  rootReducer, 
  nodeEnv === 'development' ? composeWithDevTools(middleware) : middleware
);

// axios interceptor with store access
const languageInterceptorId = setupLanguageInterceptor(axiosInstance, store);

if (nodeEnv !== 'test') {
  sagaMiddleware.run(rootSaga);
}

export const cleanupLanguageInterceptor = (): void => {
  axiosInstance.interceptors.request.eject(languageInterceptorId);
};

export default store;
